"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardUTCDate = exports.customDate = exports.longDateFormat = exports.date = exports.badge = exports.link = exports.phoneNumber = exports.dollars = exports.dueDate = exports.datePickerPopover = exports.groupedText = exports.actionMenu = exports.ActionMenuElement = exports.textLink = exports.relativeTime = exports.number = exports.email = exports.paragraph = exports.address = exports.addressInEntity = exports.text = void 0;
var tslib_1 = require("tslib");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var format_1 = (0, tslib_1.__importDefault)(require("date-fns/format"));
var libphonenumber_js_1 = require("libphonenumber-js");
var isNaN_1 = (0, tslib_1.__importDefault)(require("lodash/isNaN"));
var upperFirst_1 = (0, tslib_1.__importDefault)(require("lodash/upperFirst"));
var moment_1 = (0, tslib_1.__importDefault)(require("moment"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var s_ago_1 = (0, tslib_1.__importDefault)(require("s-ago"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../../theme");
var badge_1 = require("../../badge");
var date_picker_1 = require("../../date-picker");
var flexbox_1 = require("../../flexbox");
var icons_1 = require("../../icons");
var padding_1 = require("../../padding");
var popover_menu_1 = require("../../popover-menu");
var stack_1 = require("../../stack");
var text_1 = require("../../text");
var text_link_1 = require("../../text-link");
function text(value) {
    return (react_1.default.createElement(text_1.Text, { color: "primary", truncate: true, nowrap: true }, value || '-'));
}
exports.text = text;
function addressInEntity(value, row) {
    var addressEntity = row.entity.address;
    if (!addressEntity) {
        return (react_1.default.createElement(text_1.Text, { key: String(value), weight: 300, color: "dark" }, "Invalid address"));
    }
    var oneLineAddress = addressEntity.address, street = addressEntity.street, city = addressEntity.city, state = addressEntity.state, zip = addressEntity.zip;
    if (street && city && state && zip) {
        var cityStateZip = "".concat(city, ", ").concat(state, " ").concat(zip);
        return (react_1.default.createElement(stack_1.Stack, { direction: "vertical", gap: 2 }, [street, cityStateZip].map(function (line) { return (react_1.default.createElement(text_1.Text, { key: line, weight: 300, color: "dark" }, line)); })));
    }
    return (react_1.default.createElement(text_1.Text, { key: String(value), weight: 300, color: "dark" }, typeof value === 'string' ? value : oneLineAddress || 'Invalid address'));
}
exports.addressInEntity = addressInEntity;
function address(value, row) {
    var oneLineAddress = row.address, street = row.street, city = row.city, state = row.state, zip = row.zip;
    if (street && city && state && zip) {
        var cityStateZip = "".concat(city, ", ").concat(state, " ").concat(zip);
        return (react_1.default.createElement(stack_1.Stack, { direction: "vertical", gap: 2 }, [street, cityStateZip].map(function (line) { return (react_1.default.createElement(text_1.Text, { key: line, weight: 300, color: "dark" }, line)); })));
    }
    return (react_1.default.createElement(text_1.Text, { key: String(value), weight: 300, color: "dark" }, typeof value === 'string' ? value : oneLineAddress || 'Invalid address'));
}
exports.address = address;
function paragraph(value) {
    return react_1.default.createElement(text_1.Text, null, value || '-');
}
exports.paragraph = paragraph;
function email(value) {
    if (!value) {
        return react_1.default.createElement(text_1.Text, null, "-");
    }
    return react_1.default.createElement(text_link_1.TextLink, { href: "mailto:".concat(value) }, value);
}
exports.email = email;
function number(value) {
    return (react_1.default.createElement(text_1.Text, { textAlign: "right", truncate: true }, value || '-'));
}
exports.number = number;
function relativeTime(value) {
    if (!value) {
        return react_1.default.createElement(text_1.Text, null, "-");
    }
    return react_1.default.createElement(text_1.Text, { truncate: true }, (0, s_ago_1.default)(new Date(String(value))));
}
exports.relativeTime = relativeTime;
function textLink(textLinkAction) {
    return function (value, row) { return (react_1.default.createElement(text_link_1.TextLink, { tabIndex: 0, href: "#", onClick: function () { return textLinkAction(row); } }, value || '-')); };
}
exports.textLink = textLink;
function ActionMenuElement(_a) {
    var renderMenu = _a.renderMenu, row = _a.row;
    var tetherOptions = {
        targetAnchor: 'bottomLeft',
        anchor: 'bottomRight',
        yOffset: 2,
        xOffset: -2,
    };
    return (react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "center" },
        react_1.default.createElement(popover_menu_1.PopoverMenu, { options: tetherOptions, type: "more", label: "Open options" }, function (toggle) { return renderMenu(row, toggle); })));
}
exports.ActionMenuElement = ActionMenuElement;
function actionMenu(renderMenu) {
    return function (_value, row) { return react_1.default.createElement(ActionMenuElement, { renderMenu: renderMenu, row: row }); };
}
exports.actionMenu = actionMenu;
function groupedText(titles, subtitles) {
    var boldText = function (value) { return (react_1.default.createElement(text_1.Text, { weight: 600, color: "primary" },
        react_1.default.createElement(StyledGroupedText, null, value))); };
    var regularText = function (value) { return (react_1.default.createElement(text_1.Text, { weight: 300, color: "secondary" },
        react_1.default.createElement(StyledGroupedText, null, value))); };
    return (react_1.default.createElement(StyledGroupedTextWrapper, null,
        Array.isArray(titles) ? react_1.default.createElement("div", null, titles.map(function (v) { return boldText(v); })) : boldText(titles),
        subtitles &&
            (Array.isArray(subtitles) ? react_1.default.createElement("div", null, subtitles.map(function (v) { return regularText(v); })) : regularText(subtitles))));
}
exports.groupedText = groupedText;
var StyledGroupedTextWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  width: 100%;\n  overflow: hidden;\n"], ["\n  width: 100%;\n  overflow: hidden;\n"])));
var StyledGroupedText = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"], ["\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])));
function datePickerPopover(onChange) {
    var tetherOptions = {
        targetAnchor: 'bottomLeft',
        anchor: 'bottomRight',
        yOffset: 2,
        xOffset: -2,
    };
    return function (value, row) { return (react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "center" },
        react_1.default.createElement(popover_menu_1.PopoverMenu, { type: "clock", options: tetherOptions }, function (toggle) { return (react_1.default.createElement(padding_1.Padding, { size: 8 },
            react_1.default.createElement(date_picker_1.DatePicker, { value: value ? String(value) : undefined, onChange: function (selectedDate) {
                    onChange(row, selectedDate);
                    toggle();
                } }))); }))); };
}
exports.datePickerPopover = datePickerPopover;
function dueDate(dateAlert) {
    return function (value) {
        if (!value) {
            return react_1.default.createElement("div", null);
        }
        var mdate = moment_1.default.utc(String(value));
        var daysLeft = mdate.diff((0, moment_1.default)().startOf('day'), 'days');
        if (daysLeft === 0) {
            return (react_1.default.createElement(stack_1.Stack, { gap: 4, direction: "horizontal", alignItems: "flex-end" },
                react_1.default.createElement(text_1.Text, { truncate: true, nowrap: true, color: "alert" }, "Today"),
                react_1.default.createElement(icons_1.IconAlarm, { color: theme_1.colors.red_l })));
        }
        if (daysLeft < 0) {
            return (react_1.default.createElement(stack_1.Stack, { gap: 4, direction: "horizontal", alignItems: "flex-end" },
                react_1.default.createElement(text_1.Text, { truncate: true, nowrap: true, color: "alert" },
                    Math.abs(daysLeft),
                    " ",
                    daysLeft === -1 ? 'day' : 'days',
                    " ago"),
                react_1.default.createElement(icons_1.IconAlarm, { color: theme_1.colors.red_l })));
        }
        if (daysLeft < dateAlert) {
            return (react_1.default.createElement(stack_1.Stack, { gap: 4, direction: "horizontal", alignItems: "flex-end" },
                react_1.default.createElement(text_1.Text, { truncate: true, nowrap: true, color: "warning" },
                    daysLeft,
                    " ",
                    daysLeft === 1 ? 'day' : 'days',
                    " remaining"),
                react_1.default.createElement(icons_1.IconAlarm, { color: theme_1.colors.secondary_d })));
        }
        return (react_1.default.createElement(text_1.Text, { nowrap: true, truncate: true }, mdate.format('MMM D')));
    };
}
exports.dueDate = dueDate;
function dollars(value) {
    var formatter = new Intl.NumberFormat('en', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
        style: 'currency',
        currency: 'USD',
    });
    var numberValue = Number(value);
    if ((0, isNaN_1.default)(numberValue)) {
        return react_1.default.createElement(text_1.Text, null, "-");
    }
    return react_1.default.createElement(text_1.Text, { truncate: true }, formatter.format(numberValue));
}
exports.dollars = dollars;
function phoneNumber(value) {
    if (!value) {
        return react_1.default.createElement(text_1.Text, null, "-");
    }
    var parsedPhone = (0, libphonenumber_js_1.parsePhoneNumberFromString)(String(value), 'US');
    if (parsedPhone && parsedPhone.isValid()) {
        return react_1.default.createElement(text_link_1.TextLink, { href: parsedPhone.getURI() }, parsedPhone.formatNational());
    }
    return react_1.default.createElement(text_1.Text, null, value);
}
exports.phoneNumber = phoneNumber;
function link(getLabel) {
    return function (_value, row) {
        var _a = getLabel(row), href = _a.href, label = _a.label, isExternal = _a.isExternal;
        var target = isExternal ? '_blank' : undefined;
        return (react_1.default.createElement("a", { href: href, style: { overflow: 'hidden' }, target: target },
            react_1.default.createElement(text_1.Text, { color: "active", truncate: true, textDecoration: "underline" }, label)));
    };
}
exports.link = link;
function badge(badgeMapping, valueLabelMapping, width, borderRadiusSize) {
    return function (value) {
        if (!value) {
            return react_1.default.createElement("div", null);
        }
        var label = (0, upperFirst_1.default)(String(value));
        if (valueLabelMapping) {
            label = valueLabelMapping[String(value)];
        }
        return (react_1.default.createElement(badge_1.Badge, { size: "regular", type: badgeMapping[String(value)], width: width, borderRadiusSize: borderRadiusSize }, label));
    };
}
exports.badge = badge;
function date(value) {
    var formattedDate;
    if (!value) {
        return react_1.default.createElement(text_1.Text, null, "-");
    }
    if (typeof value === 'string') {
        formattedDate = (0, moment_1.default)(value).format('YYYY-MM-DD');
    }
    return react_1.default.createElement(text_1.Text, null, formattedDate);
}
exports.date = date;
function longDateFormat(value) {
    if (!value) {
        return react_1.default.createElement(text_1.Text, null, "-");
    }
    var formattedDate = typeof value === 'string' ? (0, format_1.default)(value, 'ddd M/D/YY h:mm A') : '';
    return react_1.default.createElement(text_1.Text, null, formattedDate);
}
exports.longDateFormat = longDateFormat;
function customDate(format) {
    return function (value) {
        if (!value) {
            return react_1.default.createElement(text_1.Text, null, "-");
        }
        var formattedDate;
        if (typeof value === 'string') {
            formattedDate = (0, moment_1.default)(value).format(format);
        }
        return react_1.default.createElement(text_1.Text, null, formattedDate);
    };
}
exports.customDate = customDate;
function standardUTCDate(value) {
    if (!value) {
        return react_1.default.createElement(text_1.Text, null, "-");
    }
    return react_1.default.createElement(text_1.Text, { display: "block" }, (0, string_formatters_1.standardUTCDateFormat)(String(value)));
}
exports.standardUTCDate = standardUTCDate;
var templateObject_1, templateObject_2;
//# sourceMappingURL=formatters.js.map